module.exports = __webpack_public_path__ + "static/media/ill_barn_ont_i_halsen.fbbe42b1.svg";